import { useState } from "react";
import { Form } from "../../common/Form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CommonDialog } from "../../common/CommonDialog";
import { useTranslation } from "react-i18next";

export function MatchDialog({visible,onOK,onCancel})
{
    const {t} = useTranslation(); 
    const [tableInfo,setTableInfo]=useState({rows:2,cols:2});

    const onChange=(formData)=>{
        setTableInfo(formData);
    };
    const _onCancel=()=>{
        onCancel();
    };
    const _onOK=()=>{
        onOK(tableInfo);
    };
    return(
        <>
        <CommonDialog header={t('Editor.Matching_table')} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <Form id="addMatchTable" formData={tableInfo} columns="1" onChange={onChange}
                fields={[
                    {id:"rows",ftype:"number",field:"rows",label:t('Editor.Rows'),step:1},
                    {id:"cols",ftype:"number",field:"cols",label:t('Editor.Columns'),step:1}
                ]}>
            </Form>	
        </CommonDialog>
        </>
    );
}